import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from "../auth/AuthContext";

const ProtectedRoute = ({ component: Component, ...rest }) => {
    const { auth } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        if (auth.token) {
            setIsAuthenticated(true);
        } else {
            setIsAuthenticated(false);
            navigate('/login', { state: { from: location.pathname } });
        }
    }, [auth, navigate, location.pathname]);

    if (!isAuthenticated) {
        return null;  // You could also return a loading spinner here if you like
    }

    return <Component {...rest} />;
};

export default ProtectedRoute;
